import { FC } from 'react';
import FamilyInfo from 'components/forms/FamilyInfo';
import IdNumber from 'components/forms/IdNumber';
import { RealNameInfoFormutil } from 'components/forms/RealNameInfo';
import UI from 'stores/ui';
import Birthday from '../components/Birthday';
import Country from '../components/Country';
import Gender from '../components/Gender';
import { BasePersonalInfoFormutil, BasePersonalInfoProps } from '../type';

export type SSNPersonalInfoFormutil = RealNameInfoFormutil & BasePersonalInfoFormutil;

export type SSNProps = BasePersonalInfoProps;

const SSN: FC<SSNProps> = props => {
    const { idNumberProps, disabled, type, familyInfoProps } = props;
    // familyInfo缺失是允许单独编辑的，familyInfoDisabled优先级比disabled高，默认取disabled
    const { disabled: familyInfoDisabled = disabled, ...restFamilyInfoProps } = familyInfoProps || {};
    const { disabled: idNumberDisabled, ...restIdNumberOptions } = idNumberProps;

    return (
        <>
            {type === 'baseinfo2' ? null : (
                <>
                    <Birthday disabled={disabled} />
                    <Gender disabled={disabled} />
                </>
            )}
            {type === 'baseinfo' ? null : (
                <>
                    <Country disabled={disabled} isSSN />
                    <IdNumber
                        needHide
                        disabled={idNumberDisabled || disabled}
                        /**
                         * 阻止自动填充
                         * https://developer.mozilla.org/zh-CN/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                         * new-password在PC谷歌浏览器下会自动推荐密码
                         * one-time-code: 表示可以填充一次性代码（例如：验证码）,这里依然可以实现阻止自动填充功能
                         * one-time-code介绍: https://robindirksen.com/blog/html-autocomplete-one-time-code
                         * 因此判断在移动端下使用new-password、pc端下使用one-time-code
                         */
                        autoComplete={UI.isMobile ? 'new-password' : 'one-time-code'}
                        {...restIdNumberOptions}
                    />
                    <FamilyInfo disabled={familyInfoDisabled} {...restFamilyInfoProps} />
                </>
            )}
        </>
    );
};

export default SSN;
